import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';
// jsbarcode loads via dynamic import on first render
import { isNullOrEmpty } from '@softline/core';


type labelTypes =
  | 'codabar'
  | 'code39'
  | 'code128'
  | 'ean13'
  | 'ean8'
  | 'itf'
  | 'upc';

@Component({
    selector: 'soft-barcode',
    imports: [],
    templateUrl: './barcode.component.html',
    styleUrls: ['./barcode.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BarcodeComponent {
  private _barcode: any

  data = input.required<string>();
  labelType = input<labelTypes>('ean13');
  size = input<'sm' | 'md' | 'lg' | undefined>('md');
  height = computed(() => {
    switch (this.size()) {
      case 'sm': return 50;
      case 'md': return 100;
      case 'lg': return 150;
      default: return 100;
    }
  });

  width = computed(() => {
    switch (this.size()) {
      case 'sm': return 1;
      case 'md': return 2;
      case 'lg': return 4;
      default: return 2;
    }
  });

  viewChild = viewChild<ElementRef>('ref');
  dataEffect = effect(() => {
    const data = this.data();
    const labelType = this.labelType();
    const viewChild = this.viewChild();

    if (isNullOrEmpty(data) || !viewChild) return;

    // signals are read above, before the await — the effect stays reactive
    const width = this.width();
    const height = this.height();

    // JsBarcode throws when the data doesn't match the chosen symbology
    // (e.g. non-Codabar characters for `codabar`). Use its `valid` callback +
    // a try/catch so an invalid combination renders nothing instead of
    // crashing the host with an uncaught error.
    void import('jsbarcode').then(({ default: JsBarcode }) => {
      try {
        this._barcode = JsBarcode(viewChild.nativeElement, data, {
          format: labelType,
          width,
          height,
          background: 'transparent',
          valid: (isValid: boolean) => {
            if (!isValid) viewChild.nativeElement.innerHTML = '';
          },
        });
      } catch {
        viewChild.nativeElement.innerHTML = '';
      }
    });
  });



  constructor() {}
}
